import { TeacherStatusTagCombinedProps } from './types';

const usePresenter = (props: TeacherStatusTagCombinedProps): TeacherStatusTagCombinedProps => {
  return props;
};

export default usePresenter;
